import { Suspense, lazy } from 'react';

const Component = lazy(() => import("./CallLog"));

function CallLog() {

  return (
    <div>
      <Suspense fallback={<div>loading...</div>}>
        <Component />
      </Suspense>
    </div>);

}

export default CallLog;

